// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Logo UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezClockerLogo_32x32 {
  border: none;
  width: 32px;
  height: 32px;
}

.ezClockerLogoImgContaner_Center {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: var(--ezClockerWhite);
  text-align: center;
}

.ezClockerLogoTextContaner_Center {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezBannerHeaderColor);
  text-align: center;
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
}

.ezClockerLogo_FullWidth {
  border: none;
  width: 85%;
  height: auto;
  text-align: center;
  vertical-align: middle;
}

.ezLogo-container-center {
  display: grid;
  padding: 4px;
  grid-template-columns: auto;
  grid-template-rows: auto;
  justify-content: center;
  align-content: center;
  background-color: var(--ezClockerWhite);
  color: var(--ezBannerHeaderColor);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  text-align: center;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 768px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 75%;
    height: auto;
  }
}
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 75%;
    height: auto;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 200px;
  }
  .ezLogo-container-center {
    padding: 0;
    background-color: var(--ezClockerWhite);
    color: var(--ezBannerHeaderColor);
    text-align: center;
    font-size: var(--ezBannerHeaderFontSize);
    font-weight: var(--ezBannerHeaderFontWeight);
    font-style: var(--ezBannerHeaderFontStyle);
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-logo.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uCAAA;EACA,iCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iCAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;;AAIA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,UAAA;IACA,YAAA;EAFN;AACF;AAMA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,UAAA;IACA,YAAA;EAJN;AACF;AAQA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,YAAA;EANN;EASE;IACI,UAAA;IACA,uCAAA;IACA,iCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4CAAA;IACA,0CAAA;EAPN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Logo UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n.ezClockerLogo_32x32 {\n    border: none;\n    width: 32px;\n    height: 32px;\n}\n\n.ezClockerLogoImgContaner_Center {\n    padding-top: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    background-color: var(--ezClockerWhite);\n    text-align: center;\n}\n\n.ezClockerLogoTextContaner_Center {\n    padding: 10px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezBannerHeaderColor);\n    text-align: center;\n    font-size: var(--ezBannerHeaderFontSize);\n    font-weight: var(--ezBannerHeaderFontWeight);\n    font-style: var(--ezBannerHeaderFontStyle);\n}\n\n.ezClockerLogo_FullWidth {\n    border: none;\n    width: 85%;\n    height: auto;\n    text-align: center;\n    vertical-align: middle;\n}\n\n.ezLogo-container-center {\n    display: grid;\n    padding: 4px;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    justify-content: center;\n    align-content: center;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezBannerHeaderColor);\n    font-size: var(--ezBannerHeaderFontSize);\n    font-weight: var(--ezBannerHeaderFontWeight);\n    font-style: var(--ezBannerHeaderFontStyle);\n    text-align: center;\n    vertical-align: middle;\n}\n\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n@media screen and (max-width: 768px) {\n    .ezClockerLogo_FullWidth {\n        border: none;\n        width: 75%;\n        height: auto;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n@media screen and (max-width: 480px) {\n    .ezClockerLogo_FullWidth {\n        border: none;\n        width: 75%;\n        height: auto;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n@media screen and (max-width: 319px) {\n    .ezClockerLogo_FullWidth {\n        border: none;\n        width: 200px;\n    }\n\n    .ezLogo-container-center {\n        padding: 0;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezBannerHeaderColor);\n        text-align: center;\n        font-size: var(--ezBannerHeaderFontSize);\n        font-weight: var(--ezBannerHeaderFontWeight);\n        font-style: var(--ezBannerHeaderFontStyle);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
